import { render, staticRenderFns } from "./filter-select.vue?vue&type=template&id=2b354561&scoped=true&"
import script from "./filter-select.vue?vue&type=script&lang=js&"
export * from "./filter-select.vue?vue&type=script&lang=js&"
import style0 from "./filter-select.vue?vue&type=style&index=0&id=2b354561&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b354561",
  null
  
)

export default component.exports